"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var once_1 = require("./once"); // TODO: replace with future implementation from npm 'events' package
// const launchDarklyProvider = LaunchDarklyClientProvider('YOUR_CLIENT_SIDE_ID');
// const featureFlagService = ClientFeatureFlagService(launchDarklyProvider);
//
// ...
//
// const leasingTeamId = 'theateam';
// const featureFlagScope = new FeatureFlagScope(leasingTeamId)
// featureFlagService.initialize(featureFlagScope);
//
// ...
//
// // Note: an enum should be used for the flag name, e.g. 'new-units', and
// // kept in the consumer's project. We don't want these enums to be in
// // the knock-utils layer or else knock-utils will have to be updated
// // everytime a feature flag is added.
// const newUnits = await featureFlagService.get('new-units', false);
// if (newUnits) {
//   ...
// }
var ClientFeatureFlagProvider = /** @class */ (function (_super) {
    __extends(ClientFeatureFlagProvider, _super);
    function ClientFeatureFlagProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ClientFeatureFlagProvider;
}(events_1.EventEmitter));
exports.ClientFeatureFlagProvider = ClientFeatureFlagProvider;
/**
 * A service that can be used in any client side JS to consume the values of feature flags. This
 * service is meant to abstract the details of the underlying provider so that the provider can be
 * swapped out with minimal changes to the calling code.
 */
var ClientFeatureFlagService = /** @class */ (function (_super) {
    __extends(ClientFeatureFlagService, _super);
    function ClientFeatureFlagService(provider) {
        var _this = _super.call(this) || this;
        _this.bypassedFlags = {};
        _this.initializationFailed = false;
        _this.alwaysReturnDefaultValues = false;
        _this.provider = provider;
        // Create a promise that can be awaited on at any point, even before initialization has begun
        _this.initialized = once_1.once(_this, 'initialized');
        return _this;
    }
    // A mechanism for bypassing feature flags in development. It can also be used in real-time, via
    // a debugger to change the value of a feature flag.
    ClientFeatureFlagService.prototype.setBypassedFlag = function (featureKey, value) {
        this.bypassedFlags[featureKey] = value;
    };
    // Setting this flag to true is puts the service in "developer mode" to avoid hitting the provider service:
    ClientFeatureFlagService.prototype.setAlwaysReturnDefaultValues = function (alwaysReturnDefaultValues) {
        this.alwaysReturnDefaultValues = alwaysReturnDefaultValues;
    };
    ClientFeatureFlagService.prototype.initialize = function (featureFlagScope) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.provider.initialize(featureFlagScope)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // An error occurred, set initializationFailed so that get() can bypass the provider. We don't want get()
                        // calls to fail when the provider has an outage.
                        this.initializationFailed = true;
                        throw err_1;
                    case 3:
                        this.emit('initialized');
                        return [2 /*return*/, this.initialized];
                }
            });
        });
    };
    ClientFeatureFlagService.prototype.get = function (featureKey, defaultValue) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.alwaysReturnDefaultValues) {
                            return [2 /*return*/, defaultValue];
                        }
                        if (!(this.bypassedFlags[featureKey] === undefined)) return [3 /*break*/, 4];
                        if (!this.initializationFailed) return [3 /*break*/, 1];
                        // We don't want get() calls to fail when the provider has an outage.
                        return [2 /*return*/, defaultValue];
                    case 1: 
                    // We wait for the initialization to complete so that calling code can feel free to call get()
                    // at any time without regard to whether initialize has already been called
                    return [4 /*yield*/, this.resolveAfterInitialized()];
                    case 2:
                        // We wait for the initialization to complete so that calling code can feel free to call get()
                        // at any time without regard to whether initialize has already been called
                        _a.sent();
                        return [2 /*return*/, this.provider.get(featureKey, defaultValue)];
                    case 3: return [3 /*break*/, 5];
                    case 4: return [2 /*return*/, this.bypassedFlags[featureKey]];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Note: waiting for this promise to resolve guarantees that initialization has completed.
    ClientFeatureFlagService.prototype.resolveAfterInitialized = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initialized];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ClientFeatureFlagService;
}(events_1.EventEmitter));
exports.ClientFeatureFlagService = ClientFeatureFlagService;
